import { useState, useEffect } from 'react';
import { CustomEditor } from './CustomEditor';
import { ROLES } from 'utils/Constants';

export const InitialTextSection = ({
  userRole,
  textForm,
  textType,
  url,
  initialHtmlContent,
  initialTextContent,
  isTextFieldDisabled,
  formData,
  handleStepOneEditorInit,
  setInitialHtmlContent,
  setInitialTextContent,
  setInitialTextWordCount,
  t,
  isNotTranslation,
  isSaveDisabled,
  isTextSaved = false,
  externalCollapseKey,
  textId,
  onDownloadWord,
  defaultExpanded = true,
  expandOnUrl = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (!expandOnUrl) return;
    if (url && !isTextSaved) {
      setIsExpanded(true);
    } else if (isTextSaved) {
      setIsExpanded(false);
    }
  }, [url, isTextSaved, expandOnUrl]);

  useEffect(() => {
    if (typeof externalCollapseKey === 'number' && externalCollapseKey > 0) {
      setIsExpanded(false);
    }
  }, [externalCollapseKey]);

  const getEditorProps = () => {
    switch (userRole) {
      case ROLES.ADMIN:
        return {
          isReadOnly: true,
          content: textForm.initialHtmlContent,
          onInit: (evt, editor) => handleStepOneEditorInit(editor),
        };

      case ROLES.WRITER: {
        const canEditInitial =
          isTextFieldDisabled || (formData && !formData.activeInitialText);

        const editorProps = {
          isReadOnly: isTextSaved || !canEditInitial,
          disabled: isTextSaved,
          content: initialHtmlContent || '',
          onInit: (evt, editor) => handleStepOneEditorInit(editor),
        };

        if (!isTextSaved) {
          editorProps.onChange = (value, editor) => {
            setInitialHtmlContent(value);
            const textValue = editor.getContent({ format: 'text' });
            setInitialTextContent(textValue || '');
            setInitialTextWordCount(editor.plugins.wordcount.getCount());
          };
        }

        return editorProps;
      }

      case ROLES.CLIENT:
        return {
          isReadOnly: true,
          content: textForm.initialHtmlContent,
          onInit: (evt, editor) =>
            setInitialTextWordCount(editor.plugins.wordcount.getCount()),
        };

      case ROLES.CONSULTANT: {
        const contentToUse = (initialHtmlContent && initialHtmlContent.trim().length > 0)
          ? initialHtmlContent
          : (initialTextContent || '');

        return {
          isReadOnly: true,
          allowConsultantEdit: false,
          content: contentToUse,
          onInit: (evt, editor) => handleStepOneEditorInit(editor),
        };
      }

      case ROLES.ADMIN_CLIENT: {
        const canEditInitial =
          isTextFieldDisabled || (formData && !formData.activeInitialText);

        const contentToUse = (initialHtmlContent && initialHtmlContent.trim().length > 0)
          ? initialHtmlContent
          : (initialTextContent || '');

        const editorProps = {
          isReadOnly: isTextSaved || !canEditInitial,
          disabled: isTextSaved,
          content: contentToUse,
          onInit: (evt, editor) => handleStepOneEditorInit(editor),
        };

        if (!isTextSaved) {
          editorProps.onChange = (value, editor) => {
            setInitialHtmlContent(value);
            const textValue = editor.getContent({ format: 'text' });
            setInitialTextContent(textValue || '');
            setInitialTextWordCount(editor.plugins.wordcount.getCount());
          };
        }

        return editorProps;
      }

      case ROLES.GLOBAL_WRITER: {
        const canEditInitial =
          isTextFieldDisabled || (formData && !formData.activeInitialText);

        const editorProps = {
          isReadOnly: isTextSaved || !canEditInitial,
          disabled: isTextSaved,
          content: initialHtmlContent || '',
          onInit: (evt, editor) => handleStepOneEditorInit(editor),
        };

        // Ne pas passer onChange si le texte est sauvegardé (lecture seule)
        if (!isTextSaved) {
          editorProps.onChange = (value, editor) => {
            setInitialHtmlContent(value);
            const textValue = editor.getContent({ format: 'text' });
            setInitialTextContent(textValue || '');
            setInitialTextWordCount(editor.plugins.wordcount.getCount());
          };
        }

        return editorProps;
      }

      default:
        return {};
    }
  };

  const editorProps = getEditorProps();

  return (
    <div className="col-12">
      <div className="box-wrapper-editor" style={{ padding: 12 }}>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: 'pointer' }}
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <div className="label-title label-text-h !mb-0" style={{ marginTop: 5, marginBottom: 5 }}>
            {userRole === ROLES.ADMIN ||
              userRole === ROLES.WRITER ||
              userRole === ROLES.ADMIN_CLIENT ||
              userRole === ROLES.GLOBAL_WRITER ||
              userRole === ROLES.CONSULTANT ? (
              <>
                <strong>{t('Texte original')}</strong>
              </>
            ) : (
              <>{t('Texte initial')}</>
            )}
          </div>

          <div className="i-13">
            <i className={`fa fa-chevron-${isExpanded ? 'up' : 'down'}`} />
          </div>
        </div>

        {isExpanded && (
          <>
            <div style={{ marginTop: 12 }}>
              <CustomEditor
                {...editorProps}
                t={t}
                textId={textId}
                onDownloadWord={onDownloadWord}
              />
            </div>

            {userRole === ROLES.ADMIN && (
              <div className="box-botom-flex">
                <div>
                  {textForm.activeInitialText ? (
                    <button className="bt-submit-disabled-y">
                      {t('Réactiver')}
                    </button>
                  ) : (
                    <button
                      className="bt-submit-y"
                      type="submit"
                      name="action"
                      value="ReactivateInitialText"
                    >
                      {t('Réactiver')}
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
